<template>
  <div class="termsAgreement">
    <div class="termsAgrDesc">
      <div @click="change">
        <img
          v-show="!checked"
          src="../../assets/img/registrationLogin/login-check.png"
          alt=""
          srcset=""
        />
        <img
          v-show="checked"
          src="../../assets/img/registrationLogin/login-checked.png"
          alt=""
          srcset=""
        />
      </div>
      我已阅读并同意
      <span class="agressTitle" @click="clickAgreement('serve')" href="#">服务条款</span>
      和
      <span class="agressTitle" @click="clickAgreement('provite')" href="#">隐私协议</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      checked: false,
    };
  },
  methods: {
    clickAgreement(type){
      this.$emit('showAgreement',type)
    },
    change() {
      this.checked = !this.checked;
      this.$emit('receivePraive', this.checked);
    },
  },
  mounted() {
    this.$emit('receivePraive', this.checked);
  },
};
</script>
<style lang="scss" scoped>
.termsAgreement {
  width: 100%;
  text-align: center;
  // position: fixed;
  // bottom: 152.17px;

  .thirdPartyLogin {
    display: flex;
    padding-bottom: 43px;
    .wx_logo {
      margin-left: 159px;
    }
    .thirdParty {
      width: 91px;
      height: 91px;
      margin-right: 80px;
    }
  }

  .termsAgrDesc {
    display: flex;
    justify-content: center;
    color: #333;
    font-weight: 400;
    font-size: 25px;
    line-height: 36px;
    img {
      width: 32px;
      height: 32px;
      margin: 0 10px 0 0;
    }
    .agressTitle {
      color: #ff6c02;
      text-decoration: underline;
    }
  }
}
</style>
